module.exports = __webpack_public_path__ + "img/cadets_teambuilding.6cc504f7.jpg";